import { render } from "./CreateTaskModal.vue?vue&type=template&id=038df63b&scoped=true"
import script from "./CreateTaskModal.vue?vue&type=script&lang=js"
export * from "./CreateTaskModal.vue?vue&type=script&lang=js"

import "./CreateTaskModal.vue?vue&type=style&index=0&id=038df63b&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-038df63b"

export default script